/* 🤖 this file was generated by svg-to-ts*/
export const icoMicrosoft: {
  name: 'microsoft';
  data: string;
} = {
  name: 'microsoft',
  data: `<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 2.5V9.55H10.05V2.5H3Z" fill="#F25024"/><path d="M10.95 2.5V9.55H18V2.5H10.95Z" fill="#80BA15"/><path d="M3 10.45V17.5H10.05V10.45H3Z" fill="#13A4EF"/><path d="M10.95 10.45V17.5H18V10.45H10.95Z" fill="#FEB90F"/></svg>`
};
